import React from 'react';
import type { LearnerAccount } from '../../../accounts';
interface ChildSelectorBarProps {
  linkedLearners: Pick<LearnerAccount, 'id' | 'displayName'>[];
  selectedChildId: string;
  onSelect: (learnerId: string) => void;
}
export function ChildSelectorBar({
  linkedLearners,
  selectedChildId,
  onSelect
}: ChildSelectorBarProps) {
  if (linkedLearners.length <= 1) return null;
  return <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-6909">
      {linkedLearners.map(learner => {
      const initial = learner.displayName.charAt(0).toUpperCase();
      const isSelected = selectedChildId === learner.id;
      return <button key={learner.id} type="button" onClick={() => onSelect(learner.id)} aria-label={`Wissel naar ${learner.displayName}`} aria-pressed={isSelected} className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 ${isSelected ? 'bg-emerald-600 text-white shadow-sm' : 'bg-white text-slate-600 hover:bg-slate-50 border border-slate-200'}`} data-id="element-6910">
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-black ${isSelected ? 'bg-white/20 text-white' : 'bg-emerald-50 text-emerald-600'}`} data-id="element-6911">
              {initial}
            </div>
            {learner.displayName}
          </button>;
    })}
    </div>;
}